export default "__VITE_ASSET__18c532fa__"